import axios from 'axios';
import c from '../helpers/constants';
import { getApiKey, getBrowserAndDeviceInfo, getCustomerID } from '../helpers/functions';

export function getInvoiceData(customerId: string, invoiceNumber: number, trnno: number, kco :number ) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.GET_INVOICE}?customerid=${encodeURIComponent(customerId)}&invoiceNumber=${invoiceNumber}&trnno=${trnno}&kco=${kco}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export async function getPaymentLink(data: string) {

  const url = c.API_ENDPOINTS.GET_PAYMENT_LINK.replace('/v1/mayne', '');

  return (
    axios({
      url: url,
      method: 'POST',
      data: {
        data: data
      },
    }).then((response: any) => {
      return response?.data;
    })
      .catch((error: any) => {
        return error.response?.data;
      })
  );

}

export function getInvoices(customerId: string, isMatting: boolean) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.LIST_INVOICES}`,
      method: 'POST',
      data: {
        acode: customerId,
        option: 'L',
        company: isMatting ? '10' : '4',
        trantype: 'I',

      },
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

